<template>
    <div>
        <template v-if="this.$USER_LOGIN.get().isAdmin && !isEdit">
            <h6 class="heading-small text-muted mb-4">เลือกขนส่งที่ต้องการใช้บริการ</h6>
            <div class="row">
                <div class="col-lg-6">
                    <label><span class="text-danger">*</span> รายชื่อขนส่ง</label>
                    <b-form-group id="input-group-1" label-for="input-1">
                        <v-select 
                            :options="courierList" 
                            v-model="inputCourier.selectCourier" 
                            :class="{ 'is-invalid bd-danger': validateData.submitted && $v.inputCourier.selectCourier.$error }" 
                            @input="$emit('selectCourierList' , $event)"
                        >
                            <template slot="option" slot-scope="option">
                                <span :class="option.icon"></span>
                                {{ option.name }} {{`[ ${option.description} ]`}}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <span :class="option.icon"></span>
                                {{ inputCourier.courierName }} {{`[ ${inputCourier.descriptionCouier} ]`}}
                            </template>
                        </v-select>
                        <div v-if="validateData.submitted && $v.inputCourier.selectCourier.required == false" class="invalid-feedback d-block">กรุณากรอกชื่อขนส่ง
                        </div>
                    </b-form-group>
                </div>
            </div>
            <hr class="my-4" />
        </template>
        <template>
            <template v-if="!rateManagement">
                <h6 class="heading-small text-muted mb-4" v-if="this.$USER_LOGIN.get().isSuperadmin || this.$USER_LOGIN.get().isShippop">เพิ่มขนส่งที่ต้องการใช้บริการ</h6>
                <h6 class="heading-small text-muted mb-4" v-else>รายละเอียดขนส่ง</h6>
            </template>
            <div class="row col-lg">
                <div class="col-lg" v-if="this.$USER_LOGIN.get().isSuperadmin || this.$USER_LOGIN.get().isShippop">
                    <div class="form-group">
                        <label><span class="text-danger">*</span> รหัสขนส่ง</label>
                        <input type="text" v-model="inputCourier.courierKey" class="form-control" :class="{ 'is-invalid':validateData.checkInput.courierKey === false || validateData.submitted && $v.inputCourier.courierKey.$error}" :disabled="isEdit || rateManagement " placeholder @change="$emit('checkCourierKeys' , true )" @input="inputCourier.courierKey = $event.target.value.toUpperCase()" />
                        <div v-if="validateData.submitted && $v.inputCourier.courierKey.required == false && !validateData.checkInput.courierKey" class="invalid-feedback d-block">
                            กรุณากรอกรหัสขนส่ง
                        </div>
                        <div v-if="validateData.checkInput.courierKey === false" class="invalid-feedback d-block">
                            กรุณากรอกรหัสขนส่งให้ถูกต้อง
                        </div>
                    </div>
                </div>
                <div class="col-lg">
                    <label><span class="text-danger">*</span> ชื่อขนส่ง</label>
                    <b-form-group>
                        <b-form-input type="text" v-model="inputCourier.courierName" :disabled="this.$USER_LOGIN.get().isAdmin || rateManagement" :class="{ 'is-invalid': validateData.submitted && $v.inputCourier.courierName.$error }"></b-form-input>
                        <div v-if="validateData.submitted && $v.inputCourier.courierName.required == false" class="invalid-feedback d-block">
                            กรุณากรอกชื่อขนส่ง
                        </div>
                    </b-form-group>
                </div>
            </div>
            <div class="row col-lg">
                <div class="col-lg-12">
                    <div class="form-group">
                        <label><span class="text-danger">*</span> รายละเอียดขนส่ง</label>
                        <input type="text" class="form-control" v-model="inputCourier.descriptionCouier" placeholder="รายละเอียดขนส่ง" :class="{ 'is-invalid': validateData.submitted && $v.inputCourier.descriptionCouier.$error}" :disabled="this.$USER_LOGIN.get().isAdmin || rateManagement" />
                        <div v-if="validateData.submitted && $v.inputCourier.descriptionCouier.required == false" class="invalid-feedback d-block">กรุณากรอกรายละเอียดขนส่ง
                        </div>
                    </div>
                </div>
            </div>
            <hr class="my-4" v-if="this.$USER_LOGIN.get().isShippop || this.$USER_LOGIN.get().isSuperadmin" />
            <div class="row flex-column col-lg">
                <h6 class="heading-small text-muted mb-4">ตั้งราคาขนส่งต่างประเทศ</h6>
                <div class="row col-lg">
                    <div class="col-12 col-lg-6">
                        <h6 class="heading-small text-muted mb-4">
                            ตั้งราคาและกำไร
                        </h6>
                        <div v-if="this.$USER_LOGIN.get().isShippop || this.$USER_LOGIN.get().isSuperadmin" class="form-group">
                            <label>
                                <span class="text-danger">*</span>ต้นทุนร้านค้า (%)
                                <span>
                                    <i class="fas fa-info-circle" v-b-tooltip title="ต้นทุนร้านค้าที่ SHIPPOP ให้กับ SHOP"></i>
                                </span>
                            </label>
                            <div>
                                <b-form-group>
                                    <input type="number" v-model="inputCourier.rate" placeholder="กรอกเปอร์เซ็นต์กำไรที่ต้องการ" class="form-control" :class="{ 'is-invalid': $v.inputCourier.rate.$error }" :disabled="rateManagement || disabledEditRate || allow_change_rate" />
                                </b-form-group>
                            </div>
                        </div>
                        <div v-if="this.$USER_LOGIN.get().isShippop || this.$USER_LOGIN.get().isSuperadmin" class="form-group">
                            <label>
                                <span class="text-danger">*</span>ต้นทุนร้านค้าขั้นต่ำ (บาท)
                            </label>
                            <b-form-group>
                                <input type="number" v-model="inputCourier.rate_min" placeholder="กรอกกำไรขั้นต่ำที่ต้องการ" class="form-control" :disabled="rateManagement || disabledEditRate || allow_change_rate" />
                            </b-form-group>
                        </div>
                        <div v-if="this.$USER_LOGIN.get().isShippop" class="form-group">
                            <label>
                                <span class="text-danger">*</span>
                                <span class="">
                                    ส่วนลดต่ำสุดที่ให้ร้านตั้งได้ (%)
                                </span>
                            </label>
                            <div>
                                <b-form-group>
                                    <input type="number" v-model="inputCourier.rate_max_discount" placeholder="กรอกเปอร์เซ็นต์" class="form-control" :disabled="rateManagement || disabledEditRate" />
                                </b-form-group>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>
                                <span class="text-danger">*</span>
                                <span class="mr-1">
                                    กำไร (%)
                                </span>
                                <span>
                                    <i class="fas fa-info-circle" v-b-tooltip title="ใช้เพื่อคำนวณราคาขาย"></i>
                                </span>
                            </label>
                            <div>
                                <b-form-group>
                                    <input type="number" v-model="inputCourier.price" placeholder="กรอกเปอร์เซ็นต์" class="form-control" :disabled="rateManagement || disabledEditRate || allow_change_price" />
                                </b-form-group>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>
                                <span class="text-danger">*</span>
                                <span class="mr-1">
                                    กำไรขั้นต่ำ (บาท)
                                </span>
                                <span>
                                    <i class="fas fa-info-circle" v-b-tooltip title="หากคำนวณกำไร (%) แล้วได้น้อยกว่ากำไรขั้นต่ำ (บาท) ระบบจะใช้กำไรขั้นต่ำในการคำนวณราคาขาย"></i>
                                </span>
                            </label>
                            <div>
                                <b-form-group>
                                    <input type="number" v-model="inputCourier.price_min" placeholder="กรอกจำนวนบาท" class="form-control" :disabled="rateManagement || disabledEditRate || allow_change_price" />
                                </b-form-group>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>
                                <span class="text-danger">*</span>ค่าบริการ (%)
                            </label>
                            <b-form-group>
                                <input type="number" v-model="inputCourier.service" placeholder="กรอกจำนวนเงินค่าบริการ" class="form-control" :disabled="rateManagement || disabledEditRate || allow_change_service" />
                            </b-form-group>
                        </div>
                        <div class="form-group">
                            <label>
                                <span class="text-danger">*</span>ค่าบริการขั้นต่ำ (บาท)
                            </label>
                            <b-form-group>
                                <input type="number" v-model="inputCourier.service_min" placeholder="กรอกจำนวนเงินค่าบริการที่ต้องการ" class="form-control" :disabled="rateManagement || disabledEditRate || allow_change_service" />
                            </b-form-group>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <h6 class="heading-small text-muted mb-4">
                            โปรแกรมทดลองคำนวณราคา
                        </h6>
                        <div v-if="this.$USER_LOGIN.get().isShippop || this.$USER_LOGIN.get().isSuperadmin">
                            <label>
                                <span class="mr-1">
                                    ต้นทุน POP SHIPPOP
                                </span>
                                <span>
                                    <i class="fas fa-info-circle"></i>
                                </span>
                            </label>
                            <div class="form-group position-relative">                                
                                <input class="form-control" disabled />
                                <div class="unit">
                                    <span>{{ parseFloat(fake_cost).toFixed(2) }} บาท</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="this.$USER_LOGIN.get().isAdmin">
                            <label>
                                <span class="mr-1">
                                    ตัวอย่างต้นทุน
                                </span>
                                <span>
                                    <i class="fas fa-info-circle" v-b-tooltip title="ราคาต้นทุนค่าขนส่ง"></i>
                                </span>
                            </label>
                            <div class="form-group position-relative fake-cost-css">                                
                                <input class="form-control" v-model="fake_cost" />
                                <!-- <div class="unit">
                                    <span>{{ parseFloat(fake_cost).toFixed(2) }} บาท</span>
                                </div> -->
                            </div>
                        </div>
                        <div>
                            <label>
                                <span class="mr-1">
                                   ต้นทุนร้านค้า
                                </span>
                                <span>
                                    <i class="fas fa-info-circle"></i>
                                </span>
                            </label>
                            <div class="form-group position-relative">
                                <input class="form-control" disabled />
                                <div class="unit">
                                    <span>{{ parseFloat(costFrontShop(false)).toFixed(2) }} บาท</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label>
                                <span class="mr-1">
                                    ราคาขายต่ำสุดที่ร้านค้า (ต้นทุนร้านค้า - ส่วนลดต่ำสุดที่ให้ร้านตั้งได้)
                                </span>
                                <span>
                                    <i class="fas fa-info-circle"></i>
                                </span>
                            </label>
                            <div class="form-group position-relative">
                                <input class="form-control" disabled />
                                <div class="unit">
                                    <span>{{ parseFloat(costFrontShop(true)).toFixed(2) }} บาท</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label>
                                <span class="mr-1">
                                    ราคาขาย
                                </span>
                                <span>
                                    <i class="fas fa-info-circle" v-b-tooltip title="ต้นทุนร้าน + กำไรที่ต้องการ(%) (แสดงเป็นราคาขายในใบเสร็จ)"></i>
                                </span>
                            </label>
                            <div class="form-group position-relative">
                                <input class="form-control" disabled />
                                <div class="unit">
                                    <span>{{ parseFloat(calPriceOnShop()).toFixed(2) }} บาท</span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label>
                                <span class="mr-1">
                                    ค่าบริการ
                                </span>
                                <span>
                                    <i class="fas fa-info-circle" v-b-tooltip title="ค่าบริการเพิ่มเติมที่ร้านสาขาสามารถตั้งได้ (แสดงบนใบเสร็จ)"></i>
                                </span>
                            </label>
                            <div class="form-group position-relative">
                                <input class="form-control" disabled />
                                <div class="unit">
                                    <span>{{ parseFloat(calServiceFromCost()).toFixed(2) }} บาท</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>     
                <div class="row col-lg" v-if="(!rateManagement && (this.$USER_LOGIN.get().isShippop || this.$USER_LOGIN.get().isSuperadmin))">
                    <div class="col-12 col-lg-12">
                        <b-form-checkbox-group
                            v-model="inputCourier.allowedCourier"
                            :options="options"
                            class="mb-3"
                            value-field="item"
                            text-field="name"
                            :disabled="disabledEditRate"
                        ></b-form-checkbox-group>
                    </div>
                </div>
                <div class="row col-lg" v-if="this.$USER_LOGIN.get().isAdmin">
                    <div class="col-lg-6 hidden-sm"></div>
                    <div class="col-6 col-lg-6 col-sm-12 ">
                        <div class="profit-formal">
                            <h3 class="text-label-profit">
                                กำไรที่ได้รับ 
                            </h3>
                            <div class="row flex-row align-items-center">
                                <p class="text-money m-0 mr-3">
                                    {{ 
                                        parseFloat(TotalCalculate()).toFixed(2)
                                    }}
                                </p>
                                <span class="text-unit">
                                    บาท
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="my-4" v-if="this.$USER_LOGIN.get().isShippop || this.$USER_LOGIN.get().isSuperadmin" />
            <div class="row flex-column col-lg" v-if="this.$USER_LOGIN.get().isShippop || this.$USER_LOGIN.get().isSuperadmin">
                <h6 class="heading-small text-muted mb-4">ระยะเวลาการใช้ราคา</h6>
                <div class="row col-lg">
                    <div class="col-lg" v-if="!this.$USER_LOGIN.get().isShippop">
                        <label>ราคานี้มีผลตั้งแต่วันที่</label>
                        <b-form-group>
                            <input type="datetime" v-model="inputCourier.effective_date" class="form-control" readonly />
                        </b-form-group>
                    </div>
                    <div class="col-lg" v-if="!this.$USER_LOGIN.get().isShippop">
                        <div class="form-group">
                            <label>ราคาสิ้นสุดวันที่</label>
                            <input type="datetime" v-model="inputCourier.expired_date" class="form-control" readonly/>
                        </div>
                    </div>
                    <div class="col-lg" v-if="this.$USER_LOGIN.get().isShippop">
                        <div class="form-group">
                            <label>ราคานี้มีผลตั้งแต่วันที่</label><small class="text-muted"> (ตั้งวันและเวลาที่จะให้ขนส่งขึ้นแสดงหน้า POS)</small>
                            <input :disabled="rateManagement" type="datetime-local" v-model="inputCourier.effective_date" class="form-control" />
                        </div>
                    </div>
                    <div class="col-lg" v-if="this.$USER_LOGIN.get().isShippop">
                        <div class="form-group">
                            <label>ราคาสิ้นสุดวันที่</label><small class="text-muted"> (ตั้งวันและเวลาที่จะให้ขนส่งหายไปจากหน้า POS)</small>
                            <input :disabled="rateManagement" type="datetime-local" v-model="inputCourier.expired_date" class="form-control" />
                        </div>
                    </div>
                </div>
            </div>
            <b-alert :show="this.$USER_LOGIN.get().isSuperadmin" variant="yellow-light" class="text-center">  
                <h4 class="text-danger">กรณีถ้ามีร้านค้าใช้เรทราคานี้แล้ว ทาง Superadmin จะไม่สามารถแก้ไขเรทราคานี้ได้</h4>
            </b-alert>
        </template>
    </div>
</template>

<script>
import {
  required, minLength
} from "vuelidate/lib/validators";

export default {
    props:{
        isWho: [Function, String],
        inputCourier: [Function, Object],
        validateData: Object,
        isEdit: Boolean,
        rateManagement: Boolean,
    },
    data() {
        return {
            valueFromOwner: {},
            fromCourier: [],
            options: this.returnOption(),
            courierList: [],
            fake_cost: 100,
            total_profit: 0,
            allow_change_rate: false,
            allow_change_price: false,
            allow_change_service: false
        }
    },
    validations() {
        return {
            inputCourier: {
                selectCourier: this.ruleValidate.selectCourier,
                descriptionCouier: this.ruleValidate.descriptionCouier,
                courierName: this.ruleValidate.courierName,
                courierKey: this.ruleValidate.courierKey,
                rate_max_discount: this.ruleValidate.rate_max_discount,
                service_min: this.ruleValidate.service_min,
                service: this.ruleValidate.service,
                price: this.ruleValidate.price,
                price_min: this.ruleValidate.price_min,
                rate_min: this.ruleValidate.rate_min,
                rate: this.ruleValidate.rate,
                effective_date: this.ruleValidate.effective_date
            }
        }
    },
    methods: {
        disabledManageCost(allow) {
            this.allow_change_rate = allow === 0 ? true : false
        },
        disabledManagePrice(allow) {
            this.allow_change_price = allow === 0 ? true : false
        },
        disabledManageService(allow) {
            this.allow_change_service = allow === 0 ? true : false
        },
        setCostWithSuperadmin() {

        },
        returnCostFrom(courier_inter_rates) {
            const { rate, rate_min } = courier_inter_rates[0]
            const profitFromCourierPercent = parseFloat((this.fake_cost * rate) / 100)
            const profitFromCourierBath = parseFloat(rate_min)
            const real_ProfitFromCourier= profitFromCourierBath > profitFromCourierPercent ? profitFromCourierBath : profitFromCourierPercent
            return parseFloat(this.fake_cost) + parseFloat(real_ProfitFromCourier)
        },
        // returnCalCostFromSuperadmin(courier_inter_rates) {
        //     const { rate, rate_min } = courier_inter_rates[0]
        //     const profitFromCourierPercent = parseFloat((this.fake_cost * rate) / 100)
        //     const profitFromCourierBath = parseFloat(rate_min)
        //     const real_ProfitFromCourier= profitFromCourierBath > profitFromCourierPercent ? profitFromCourierBath : profitFromCourierPercent
        //     return parseFloat(this.fake_cost) + parseFloat(real_ProfitFromCourier)
        // },
        // returnCalCostFromShippop(allObjectSuperadmin) {
        //     const { courier_inter_rates } = allObjectSuperadmin.from_courier_inter
        //     const { rate, rate_min } = courier_inter_rates[0]
        //     const profitFromCourierPercent = parseFloat((this.fake_cost * rate) / 100)
        //     const profitFromCourierBath = parseFloat(rate_min)
        //     const real_ProfitFromCourier= profitFromCourierBath > profitFromCourierPercent ? profitFromCourierBath : profitFromCourierPercent
        //     return parseFloat(this.fake_cost) + parseFloat(real_ProfitFromCourier)
        // },
        async setUpVariable() {
            if(this.$USER_LOGIN.get().isSuperadmin) {
                const { from_courier_inter } = this.inputCourier
                const { courier_inter_rates, allow_change_price, allow_change_service, allow_change_rate } = from_courier_inter
                // this.valueFromOwner = courier_inter_rates[0]
                this.disabledManageCost(allow_change_rate)
                this.disabledManagePrice(allow_change_price)
                this.disabledManageService(allow_change_service)
                this.returnOption()
                const costShippop = this.returnCostFrom(courier_inter_rates)
                this.fake_cost = costShippop
            }else if (this.$USER_LOGIN.get().isAdmin) {
                if(this.isEdit) {
                    this.setUpEditPageAdmin()
                }else if (this.inputCourier.selectCourierType === 'selectedLates') {
                    this.setUpWhenUserAdminSelected()
                }
            }
        },
        async setUpWhenUserAdminSelected() {
            const courier = this.inputCourier.selectCourier

            if(courier.type === 'SHIPPOP') {
                const { courier_inter_rates, allow_change_price, allow_change_service, allow_change_rate } = courier
                this.disabledManageCost(allow_change_rate)
                this.disabledManagePrice(allow_change_price)
                this.disabledManageService(allow_change_service)
                const costShippop = await this.returnCostFrom(courier_inter_rates)
                this.fake_cost = costShippop
            }else if (courier.type === 'SUPERADMIN') {
                const { courier_inter_rates, allow_change_price, allow_change_service, allow_change_rate, ...allObjectSuperadmin } = courier
                this.disabledManageCost(allow_change_rate)
                this.disabledManagePrice(allow_change_price)
                this.disabledManageService(allow_change_service)
                if(allObjectSuperadmin.from_courier_inter.type === "SHIPPOP") {
                    const costShippop = await this.returnCostFrom(allObjectSuperadmin.from_courier_inter.courier_inter_rates)
                    this.fake_cost = costShippop
                }
                const costSuperadmin = await this.returnCostFrom(courier_inter_rates)
                this.fake_cost = costSuperadmin
            }
        },
        async setUpEditPageAdmin() {
            const { from_courier_inter } = this.inputCourier
            if(from_courier_inter.type === "SUPERADMIN") {
                const { courier_inter_rates, allow_change_price, allow_change_service, allow_change_rate, ...allObjectSuperadmin } = from_courier_inter
                this.disabledManageCost(allow_change_rate)
                this.disabledManagePrice(allow_change_price)
                this.disabledManageService(allow_change_service)
                if(allObjectSuperadmin.from_courier_inter.type === "SHIPPOP") {
                    const costShippop = await this.returnCostFrom(allObjectSuperadmin.from_courier_inter.courier_inter_rates)
                    this.fake_cost = costShippop
                }
                const costSuperadmin = await this.returnCostFrom(courier_inter_rates)
                this.fake_cost = costSuperadmin
            } else if (from_courier_inter.type === "SHIPPOP") {
                const { courier_inter_rates, allow_change_price, allow_change_service, allow_change_rate } = from_courier_inter
                this.disabledManageCost(allow_change_rate)
                this.disabledManagePrice(allow_change_price)
                this.disabledManageService(allow_change_service)
                const costShippop = await this.returnCostFrom(courier_inter_rates)
                this.fake_cost = costShippop
            }
        },
        returnOption() {
            let optionValue = [
                    { item: 'allow_change_rate', name: 'ไม่อนุญาตให้แก้ไขทุนร้านค้า' },
                    { item: 'allow_change_price', name: 'ไม่อนุญาตให้แก้ไขราคาขาย' },
                    { item: 'allow_change_service', name: 'ไม่อนุญาตให้แก้ไขค่าบริการ' }
            ]
            if(this.$USER_LOGIN.get().isSuperadmin) {
                optionValue = [
                    { item: 'allow_change_price', name: 'ไม่อนุญาตให้แก้ไขราคาขาย' },
                    { item: 'allow_change_service', name: 'ไม่อนุญาตให้แก้ไขค่าบริการ' }
                ]
                // ****ได้โปรดอย่าลบเพื่อคนรุ่นหลัง 555****
                // action มาจาก function setUpVariable() 
                // โหลด รอบแรกถ้า role ก่อนหน้าไม่ได้ติ้กก็จะโชว์ครบ รอบแรกนี้หมายถึง Start Components ด้วย mounted นะแจ๊ะ
                // โหลด รอบสองจาก api ของ parent component นี้ที่เซ็ต inputCourier เสร็จ จะไป call setUpVariable() จาก ref
                // group ใหม่อีกรอบถ้า inputCourier.allowedCourier จาก role ก่อนหน้าไม่มี เอาออกไม่ให้ติ้กไม่อยากโชว์อะ
                // ********************************
                optionValue = optionValue.filter((value) => {
                  return !this.inputCourier.allowedCourier.includes(value.item);
                });
                this.options = optionValue
            }
            return optionValue
        },
        calPriceOnShop() {
            // คิดจาก ต้นทุนร้านค้า
            const costClean = parseFloat(this.costFrontShop(false))
            const price_percent = parseFloat(this.inputCourier.price) ? parseFloat(this.inputCourier.price) : 0 
            const price_min_bath = parseFloat(this.inputCourier.price_min) ? parseFloat(this.inputCourier.price_min) : 0
            const price_of_percent = (costClean * price_percent) / 100
            const price_real = price_min_bath > price_of_percent ? price_min_bath : price_of_percent
            return costClean + price_real
        },
        calServiceFromCost(cost = this.fake_cost){
            const min_service = parseFloat(this.inputCourier.service_min) ? parseFloat(this.inputCourier.service_min) : 0
            const percent_service = parseFloat(this.inputCourier.service) ? parseFloat(this.inputCourier.service) : 0

            const service_cal_percent = (percent_service * cost) / 100

            return service_cal_percent > min_service ? service_cal_percent : min_service
        },
        calDiscountFromCost(cost) {
            const discount = (parseFloat(cost) * parseFloat(this.inputCourier.rate_max_discount)) / 100
            return parseFloat(cost) - parseFloat(discount)
        },
        costFrontShop(calDiscount = false) {
            if(this.isWho === 'shippop' || this.isWho === 'superadmin') {
                const percent_profit = parseFloat(this.inputCourier.rate) ? parseFloat(this.inputCourier.rate) : 0;
                const cost_example = parseFloat(this.fake_cost);
                const rate_min = parseFloat(this.inputCourier.rate_min) ? parseFloat(this.inputCourier.rate_min) : 0;
                let cost_from_percent;
                if (percent_profit >= 0) {
                    cost_from_percent = ((percent_profit * cost_example) / 100) + cost_example;
                } else {
                    cost_from_percent = cost_example - ((Math.abs(percent_profit) * cost_example) / 100);
                }
                const cost_min = rate_min + cost_example;
                const cost_real = cost_min > cost_from_percent ? cost_min : cost_from_percent;
                return calDiscount ? this.calDiscountFromCost(cost_real) : parseFloat(cost_real);
            }
            return this.fake_cost
        },
        adminGetDefaultCouriers() {
            this.$emit('handleLoader')
            this.$http
                .get(this.$API_URL + `/inter/list/default/courier`, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    this.courierList = res.data.data
                    this.$emit('handleLoader')
                })
                .catch(() => {});
        },
        TotalCalculate() {
            if(this.isWho === 'shippop' || this.isWho === 'superadmin') {
                const percent_profit = parseFloat(this.inputCourier.rate) ? parseFloat(this.inputCourier.rate) : 0
                const rate_min = parseFloat(this.inputCourier.rate_min) ? parseFloat(this.inputCourier.rate_min) : 0
                const service_min = parseFloat(this.inputCourier.service_min) ? parseFloat(this.inputCourier.service_min) : 0
                const cost_example = parseFloat(this.fake_cost)
                const profit_from_percent = ((percent_profit * cost_example) / 100 )
                const profit_real = rate_min >= profit_from_percent ? rate_min : profit_from_percent
                return (parseFloat(profit_real) + service_min)
            }else {
                const percent_price = parseFloat(this.inputCourier.price) ? parseFloat(this.inputCourier.price) : 0
                const bath_price = parseFloat(this.inputCourier.price_min) ? parseFloat(this.inputCourier.price_min) : 0
                const percent_service = parseFloat(this.inputCourier.service) ? parseFloat(this.inputCourier.service) : 0
                const bath_service = parseFloat(this.inputCourier.service_min) ? parseFloat(this.inputCourier.service_min) : 0
                const profit_price_percent = (parseFloat(this.fake_cost) * percent_price) / 100
                const profit_service_percent = (parseFloat(this.fake_cost) * percent_service) / 100
                const profit_price_real = bath_price >= profit_price_percent ? bath_price : profit_price_percent
                const profit_service_real = bath_service >= profit_service_percent ? bath_service : profit_service_percent
                return parseFloat(profit_price_real) + parseFloat(profit_service_real)
            }
           
        },
    },
    computed: {
        disabledEditRate() {
            console.log('this.disable_edit_rate: ', this.inputCourier.disable_edit_rate)
            return this.inputCourier.disable_edit_rate
        },
        ruleValidate() {
            let rule = {
                rate_max_discount: {
                    required
                },
                service_min: {
                    required
                },
                service: {
                    required
                },
                price: {
                    required
                },
                price_min: {
                    required
                },
                rate_min: {
                    required
                },
                rate: {
                    required,
                },
                descriptionCouier: {
                    required
                },
                courierName: {
                    required
                },
                courierKey: {
                    required
                },
                effective_date: {
                    required
                },
                selectCourier: {}
            }
            if(this.isWho === 'admin') {
                rule = {
                    selectCourier: {
                        required
                    },
                    rate_max_discount: {},
                    service_min: {
                        required
                    },
                    service: {
                        required
                    },
                    price: {
                        required
                    },
                    price_min: {
                        required
                    },
                    rate_min: {},
                    rate: {},
                    descriptionCouier: {},
                    courierName: {},
                    courierKey: {},
                    effective_date: {}
                }
                if(this.isEdit) {
                    rule.selectCourier = {}
                }
            }
            if(this.isWho === 'superadmin') {
                rule = {
                    rate_max_discount: {},
                    service_min: { required },
                    service: { required },
                    price: {
                        required
                    },
                    price_min: {
                        required
                    },
                    rate_min: { required },
                    rate: { required },
                    descriptionCouier: { required },
                    courierName: { required },
                    courierKey: { required },
                    effective_date: {},
                    selectCourier: {}
                }
            }
            return rule
        },
    },

    mounted() {
        // console.log('this. logged: ', this.valueFromOwner)
    }
}
</script>
<style lang="scss" scoped>

.fake-cost-css {
    .form-control {
        input {
            float: right;
            clear: both;
        }
    }
}
.unit {
    position: absolute;
    right: 10%;
    bottom: 25%;
}
</style>
